var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.productTemplateDesignId)?[_c('OverlappedPreview',_vm._g({staticClass:"preview",attrs:{"preview-urls":_vm.productTemplatePreviewUrls,"rounded":_vm.productTemplateIsRounded,"edit-button":_vm.editButton}},_vm.$listeners))]:_c('img',{staticClass:"placeholder",attrs:{"src":"/static/images/dashboard/placeholder_card.svg"}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c59a543","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ProductTemplatePreview.vue
// module id = STbH
// module chunks = 1